import React from 'react';

import * as S from './SliderArrowsStyles';

export function SliderArrowNext(props) {
	const { className, onClick, isMobile, customClass, customClick } = props;
	const arrowClickHandler = () => {
		if (customClick) {
			customClick();
		}
		onClick && onClick();
	};
	return !isMobile ? (
		<S.ArrowNextButton className={`${className} ${customClass}`} onClick={arrowClickHandler} />
	) : null;
}

export function SliderArrowPrev(props) {
	const { className, onClick, isMobile, customClass, customClick } = props;
	const arrowClickHandler = () => {
		if (customClick) {
			customClick();
		}
		onClick && onClick();
	};
	return !isMobile ? (
		<S.ArrowPrevButton className={`${className} ${customClass}`} onClick={arrowClickHandler} />
	) : null;
}
